module.exports = __webpack_public_path__ + "static/img/rank_47.8cd95d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_47.png
// module id = 1g6I
// module chunks = 1